"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageTypes = void 0;
var StorageTypes;
(function (StorageTypes) {
    StorageTypes["WRITE"] = "WRITE";
    StorageTypes["REMOVE"] = "REMOVE";
})(StorageTypes = exports.StorageTypes || (exports.StorageTypes = {}));
//# sourceMappingURL=StorageTypes.js.map